<template>
  <div class="w-100 mt-5">
    <div class="row">
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo :cardData="cards.buyer" title="Buyer" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo :cardData="cards.seller" title="Seller" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo :cardData="cards.refund_status" title="Refund Status" />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="card text-start p-3 m-2">
        <div class="info-container">
          <div class="content">
            <span class="fw-bold">Refund Info</span>
            <div class="row">
              <label class="col-sm-4 col-form-label">Amount</label>
              <div class="col-sm-8">
                <p class="fw-bold">
                  {{ filters.rupiah(data_product.total) }}
                </p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Payment Method</label>
              <div class="col-sm-8">
                <p class="fw-bold">{{ data.order?.payment_method  || "-" }}</p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Account Number</label>
              <div class="col-sm-8">
                <p class="fw-bold">{{ data.paid_account|| "-" }}</p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Paid Date</label>
              <div class="col-sm-8">
                <p class="fw-bold">
                  {{
                    filters.dateFull(data.paid_date, { separator: false })
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="content">
            <p class="fw-bold"><br /></p>
            <div class="row">
              <label class="col-sm-4 col-form-label">Buyer Phone No.</label>
              <div class="col-sm-8">
                <p class="fw-bold">{{ data.buyer_phone|| "-" }}</p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Cancelled By</label>
              <div class="col-sm-8">
                <p class="fw-bold">{{ data.cancel_by }}</p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Cancelled Reason</label>
              <div class="col-sm-8">
                <p class="fw-bold">{{ data.cancel_reason || " - " }}</p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Cancelled Date</label>
              <div class="col-sm-8">
                <p class="fw-bold">
                  {{
                    filters.dateFull(data.cancel_date, {
                      separator: false,
                    })
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="this.refund_status === 'REFUNDED'" class="content">
            <p class="fw-bold"><br /></p>
            <div class="row">
              <label class="col-sm-4 col-form-label">Refunded Date</label>
              <div class="col-sm-8">
                <p class="fw-bold">
                  {{
                    filters.dateFull(data.refund_date, {
                      separator: false,
                    })
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="this.refund_status === 'REJECTED'" class="content">
            <p class="fw-bold"><br /></p>
            <div class="row">
              <label class="col-sm-4 col-form-label">Rejected Reason</label>
              <div class="col-sm-8">
                <p class="fw-bold">{{ data.refund_reject_reason || "-" }}</p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">Rejected Date</label>
              <div class="col-sm-8">
                <p class="fw-bold">
                  {{
                    filters.dateFull(data.reject_date, {
                      separator: false,
                    })
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-md-7">
            <div class="d-flex mb-3">
              <div class="d-flex align-items-center" style="width: 60%">
                <div
                  class="me-3"
                  style="
                    background-color: #e0e3ec;
                    justify-content: center;
                    align-self: center;
                    width: fit-content;
                  "
                >
                  <img
                    :src="filters.storeImageParse(seller.photo)"
                    style="height: min-content"
                    width="30"
                    alt=""
                  />
                </div>
                <div>
                  {{ seller.name }}
                  <br />
                  <font-awesome-icon
                    icon="fa-solid fa-location-dot"
                    class="pe-2 text-secondary"
                  />
                  <span class="fw-bold text-secondary">{{ seller.city }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-end" style="width: 40%">
                <span class="text-start fw-bold">
                  Customer Order ID
                  <br />
                  <span class="fw-bold text-primary">{{
                    data.order_seller_id
                  }}</span>
                </span>
              </div>
            </div>
            <div>
              <div class="product-list header">
                <div class="list product">PRODUCT NAME</div>
                <div class="list price">PRODUCT PRICE</div>
                <div class="list qty">QTY</div>
                <div class="list total">SUBTOTAL</div>
              </div>
              <div
                class="product-list"
                v-for="val in productItems"
                :key="val.product_id"
              >
                <div class="list product">
                  <Image
                    :src="filters.imageParse(val.image_url)"
                    :width="36"
                    :height="36"
                    className="rounded me-3"
                  />
                  <p>
                    <router-link
                      :to="'/products/detail/' + val.product_id"
                      class="text-decoration-none fw-bold"
                      style="color: #5e50a1; cursor: pointer"
                    >
                      {{
                        `${val.product_name} ${
                          val.variant_name ? ` - ${val.variant_name}` : ""
                        }`
                      }}
                    </router-link>
                  </p>
                </div>
                <div class="list price">
                  <div v-if="val.price_regular > val.price">
                    <span class="text-decoration-line-through">
                      {{ filters.rupiah(val.price_regular) }}
                    </span>
                    <br />
                    <span>
                      {{ filters.rupiah(val.price) }}
                    </span>
                  </div>
                  <span v-else>
                    {{ filters.rupiah(val.price) }}
                  </span>
                </div>
                <div class="list qty">{{ val.quantity }}</div>
                <div class="list total">
                  {{ filters.rupiah(val.quantity * val.price) }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row fw-bold">
              <label class="col-sm-6">Subtotal Produk</label>
              <div class="col-sm-6 text-end">
                <p>
                  {{ filters.rupiah(data_product.subtotal_product_regular) }}
                </p>
              </div>
            </div>
            <div v-for="val in productItems" :key="val.product_id" class="row">
              <label class="col-sm-6"
                >{{
                  `${val.product_name} ${
                    val.variant_name ? ` - ${val.variant_name}` : ""
                  }`
                }}
              </label>
              <div class="col-sm-6 text-end">
                <p
                  v-if="val.price_regular > val.price"
                  class="text-decoration-line-through"
                >
                  {{ filters.rupiah(val.quantity * val.price_regular) }}
                </p>
                <p>
                  {{ filters.rupiah(val.quantity * val.price) }}
                </p>
              </div>
            </div>
            <hr />
            <div class="row fw-bold">
              <label class="col-sm-6">Potongan Produk Langsung</label>
              <div class="col-sm-6 text-end">
                -{{ filters.rupiah(data_product.discount_product) }}
              </div>
            </div>
            <div class="row fw-bold">
              <label class="col-sm-6">Voucher Diskon Produk</label>
              <div class="col-sm-6 text-end">
                -{{ filters.rupiah(data_product.discount_voucher_product) }}
              </div>
            </div>
            <div 
              v-if="data_product.product_voucher"
              class="d-flex" 
              style="justify-content: space-between"
            >
              <div>{{data_product.product_voucher}}</div>
            </div>
            <hr />
            <div class="row fw-bold">
              <label class="col-sm-6">Subtotal Ongkir</label>
              <div class="col-sm-6 text-end">
                <p>
                  {{ filters.rupiah(data_product.subtotal_ongkir) }}
                </p>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-6"
                >Ongkir {{ seller.name }}
              </label>
              <div class="col-sm-6 text-end">
                <p>
                  {{ filters.rupiah(data_product.ongkir) }}
                </p>
              </div>
            </div>
            <div class="row fw-bold">
              <label class="col-sm-6">Voucher Diskon Ongkir</label>
              <div class="col-sm-6 text-end">
                <p>
                  -{{ filters.rupiah(data_product.discount_voucher_ongkir) }}
                </p>
              </div>
            </div>
            <div 
              v-if="data_product.shipment_voucher"
              class="d-flex" 
              style="justify-content: space-between"
            >
              <div>{{data_product.shipment_voucher}}</div>
            </div>
            <hr />
            <div class="row fw-bold">
              <label class="col-sm-6 text-danger">Refund</label>
              <div class="col-sm-6 text-end text-danger">
                <p>
                  {{ filters.rupiah(data_product.refund) }}
                </p>
              </div>
            </div>
            <hr />
            <div class="mb-3 row fw-bold">
              <label class="col-sm-6">Total</label>
              <div class="col-sm-6 text-end">
                <p>
                  {{ filters.rupiah(data_product.total) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="refund_status === 'PENDING'" class="row">
      <div class="col-md-12">
        <a
          class="btn btn-lg btn-danger me-3"
          data-bs-target="#reject-modal"
          data-bs-toggle="modal"
          style="width: 120px"
        >
          <strong>REJECT</strong>
        </a>
        <a
          class="btn btn-lg btn-outline-danger"
          data-bs-target="#approve-modal"
          data-bs-toggle="modal"
          style="width: 160px"
        >
          <strong>REFUND</strong>
        </a>
      </div>
    </div>

    <ApproveModal :payload="dataApprove" />
    <RejectModal :payload="dataReject" />
  </div>
</template>

<script>
import ApproveModal from "@/components/modals/Approve";
import RejectModal from "@/components/modals/Reject";
import CardInfo from "@/components/CardInfo.vue";
import Image from "@/components/Image.vue";

export default {
  components: {
    ApproveModal,
    RejectModal,
    CardInfo,
    Image
  },
  created() {
    const listRoute = this.$route.path.split("/");
    this.id = listRoute[listRoute.length - 1];
    this.dataApprove.body.order_seller_refund_id = this.id;
    this.dataReject.body.order_seller_refund_id = this.id;
    this;
  },
  data() {
    return {
      id: "",
      data: {},
      data_product: {},
      seller: {},
      refund_status: "",
      cards: {
        buyer: {
          value: "",
          color: "green",
          color_text: "#5E50A1",
        },
        seller: {
          value: "",
          color: "yellow",
          color_text: "#5E50A1",
        },
        refund_status: {
          value: "",
          color: "yellow",
          color_text: "#5E50A1",
        },
      },
      productItems: [],
      dataApprove: {
        formLabel: "Select Refund Date",
        titleModal: "REFUND APPROVE",
        textButton: "REFUND",
        actionPath: "refunds/approve",
        body: {
          order_seller_refund_id: "",
          approve_time: "",
        },
      },
      dataReject: {
        formLabel: "Enter rejection reason",
        titleModal: "REJECT REFUND",
        textButton: "REJECT",
        actionPath: "refunds/reject",
        body: {
          order_seller_refund_id: "",
          reason: "",
        },
      },
    };
  },
  methods: {
    parseColor(status) {
      if (status == "PENDING") return "#FFB200";
      if (status == "REFUNDED") return "#30CB9D";
      if (status == "REJECTED") return "#ED413F";
      return "";
    },
    async getData() {
      const response = await this.$store.dispatch("refunds/show", this.id);
      this.data = response
      this.dataApprove.minDate = this.data.cancel_date
      this.seller = {
        name: response.seller_store_name,
        photo: response?.seller_photo_url,
        ...response.location_origin,
      };
      this.refund_status = response.order_seller_refund_status;

      this.cards = {
        buyer: {
          value: response.buyer_name,
          color: "green",
        },
        seller: {
          value: this.seller.name,
          color: "yellow",
        },
        refund_status: {
          value: this.filters.capitalize(this.refund_status),
          color: "yellow",
          color_text: this.parseColor(this.refund_status),
        },
      };

      this.productItems = response.product_items;

      this.data_product = {
        subtotal_product_regular: response.order_seller_pricing.subtotal_product_price_regular,
        subtotal_ongkir: response.order_seller_pricing.shipment_cost,
        discount_product: response.order_seller_pricing.subtotal_product_discount,
        discount_voucher_product: response.order_seller_pricing.discount_product_voucher,
        discount_voucher_ongkir: response.order_seller_pricing.discount_shipment_cost,
        admin_fee: response.order_seller_pricing.admin_fee,
        refund: response.order_seller_pricing.total_payment,
        total: response.order_seller_pricing.total_payment,
        ongkir: response.order_seller_pricing.shipment_cost,
        product_voucher: response.order_seller_pricing.code_discount_product_voucher,
        shipment_voucher: response.order_seller_pricing.code_discount_shipment_voucher,
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.info-container {
  display: flex;
  flex-wrap: wrap;
  .content {
    flex: 1;
    min-width: 300px;

    div {
      align-self: center;
    }
  }
}

.product-list {
  display: flex;
  padding: 1rem;
  background-color: #f9f9fc;
  border-bottom: 2px solid #ebedf3;

  &.header {
    background-color: #f3f2f8;
  }

  .list {
    display: flex;
    align-items: center;

    &.product {
      width: 34%;
    }
    &.price {
      width: 35%;
    }
    &.qty {
      width: 22%;
    }
    &.total {
      width: 9%;
    }
  }
}

.error-border {
  border: 1px red solid !important;
}

p {
  margin: 0;
}
</style>
